module.exports = __webpack_public_path__ + "static/media/leaving-the-broadcast.0873571e.svg";